import styled from 'styled-components';
import PropTypes from 'prop-types';
import React from 'react';
import ElasticAutocomplete from '../../js/components/elastic-autocomplete/elastic-autocomplete';
import { Input } from '../';
import { InputStyle } from './shared';

import { colors, Theme } from '../theme';

const renderInput = props => <Input {...props} />;

const Autocomplete = ({ className, ...rest }) => (
  <div className={className}>
    <ElasticAutocomplete classPrefix={className} renderInputComponent={renderInput} {...rest} />
  </div>
);

Autocomplete.propTypes = {
  className: PropTypes.string.isRequired
};

const Styled = styled(Autocomplete)`
  width: 100%;
  @media (min-width: ${props => props.theme.breakpoints.sm}rem) {
    font-size: 14px;
  }
  input {
    ${InputStyle};
  }

  & {
    &__section-title {
      padding: 10px 46px;
      color: ${colors.GREY};

      svg {
        position: absolute;
        left: 16px;
      }
    }

    &__container {
      position: relative;
      width: 100%;
      font-size: 14px;
    }

    &__suggestions-container {
      display: none;

      &--open {
        top: calc(100% + 2px);
        background-color: ${colors.LIGHT_GREY};
        text-align: left;
        border-radius: 4px;
        display: block;
        width: 100%;
        position: absolute;
        z-index: 10000;
        box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.2);
      }
    }

    &__suggestions-list {
      background-color: ${Theme.snow};
      margin: 0;
      padding: 5px;
      list-style-type: none;
    }

    &__suggestion {
      display: block;
      padding: 10px 10px;
      display: inline-block;
      width: 100%;
      height: 100%;
      border-radius: 4px;
      &__thumbnail {
        height: 40px;
        width: 40px;
        display: inline-block;
        vertical-align: middle;
        background-size: contain;
        background-repeat: no-repeat;
        margin-right: 10px;
        background-position: center;
      }
      &__business-name {
        max-width: 75%;
        overflow: hidden;
        color: ${colors.HIPAGES_CHARCOAL};
        text-decoration: none;
        display: inline-block;
        vertical-align: middle;
      }
      &__text {
        display: inline-block;
        vertical-align: middle;
        color: ${colors.GREY};

        span {
          color: ${colors.HIPAGES_CHARCOAL};
        }

        &__business-name {
          max-width: 176px;
          overflow: hidden;
          color: ${colors.HIPAGES_CHARCOAL};
          text-decoration: none;
          display: inline-block;
          vertical-align: middle;

          @media (min-width: ${props => props.theme.breakpoints.sm}rem) {
            max-width: 186px;
          }

          @media (min-width: ${props => props.theme.breakpoints.md}rem) {
            max-width: 270px;
          }

          @media (min-width: ${props => props.theme.breakpoints.lg}rem) {
            max-width: 600px;
          }
        }
        &__location {
          font-size: 11px;
          margin-top: 2px;
          color: ${colors.GREY};
        }
      }

      &--highlighted {
        background-color: ${colors.LIGHT_GREY};
        border-radius: 4px;
        cursor: pointer;
      }
    }
  }
`;

export default Styled;
